import { ChangePasswordSection } from '../../components/ChangePasswordSection';
import { WhiteLabelSettings } from '../../components/coach/WhiteLabelSettings';

export function CoachAccountSettings() {
  return (
    <div className="min-h-screen bg-brand-5 py-8 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <h1 className="text-heading-sm text-gray-80">Account Settings</h1>
          <p className="text-text-md text-gray-50">Manage your account preferences and security</p>
        </div>

        <div className="mb-8">
          <WhiteLabelSettings />
        </div>

        <ChangePasswordSection />
      </div>
    </div>
  );
}
